<section class="hsxWrap"
         [class.hsxWrapMin]="minimized"
         [attr.aria-label]="title">

    <!-- Slim chrome rail sits ABOVE the section content (in normal flow,
         not absolutely positioned) so it never overlaps the section's
         own header buttons. Single button: toggle minimize/expand.
         State is persisted to localStorage so reloads remember it. -->
    <div class="hsxRail">
        <button type="button"
                class="hsxBtn"
                (click)="onToggleMinimize($event)"
                [matTooltip]="(minimized ? 'ai.home_sec_expand' : 'ai.home_sec_minimize') | transloco"
                [attr.aria-expanded]="!minimized"
                [attr.aria-label]="(minimized ? 'ai.home_sec_expand' : 'ai.home_sec_minimize') | transloco">
            <mat-icon>{{ minimized ? 'unfold_more' : 'unfold_less' }}</mat-icon>
        </button>
    </div>

    @if (minimized) {
        <button type="button"
                class="hsxStrip"
                (click)="onExpand()"
                [attr.aria-label]="('ai.home_sec_expand' | transloco) + ' ' + title">
            <span class="hsxStripIcon"><mat-icon>{{ icon }}</mat-icon></span>
            <span class="hsxStripTitle">{{ title }}</span>
            <span class="hsxStripHint">{{ 'ai.home_sec_click_expand' | transloco }}</span>
            <mat-icon class="hsxStripCaret">expand_more</mat-icon>
        </button>
    } @else {
        <div class="hsxBody">
            <ng-content></ng-content>
        </div>
    }
</section>
